module.exports = __webpack_public_path__ + "media/packs/images/flags/GT-e10d9709d909a05e354ca296b2d4447f.png";